// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".index__container__3v0QG {\n  width: 240px;\n}\n", "",{"version":3,"sources":["webpack://./src/components/HelpErrorBoundary/index.less"],"names":[],"mappings":"AAEA;EACE,YAAA;AADF","sourcesContent":["@import \"@/style/themes/default.less\";\n\n.container {\n  width: @help-width;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "index__container__3v0QG"
};
export default ___CSS_LOADER_EXPORT___;
